<template>
  <div>
    <search-supplier-module @submit="submitSearch" />

    <div class="simiot-table-operation-buttons">
      <a-space>
        <a-button
          v-if="isAdmin"
          type="primary"
          @click="showDeleteToInventoryModal"
        >删模组退库</a-button>
      </a-space>
    </div>

    <a-table
      size="middle"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :scroll="{ x: 'max-content' }"
      :pagination="false"
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      row-key="id"
    />

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />

    <delete-modules-to-inventory
      v-if="isShowDeleteToInventoryModal"
      :visible.sync="isShowDeleteToInventoryModal"
      :imeis="selectedImeis"
      :module-supplier-id="moduleSupplierId"
      @completed="fetchData"
    />
  </div>
</template>

<script>
import { findModuleSupplierModules } from '@/api/module_supplier'
import Pagination from '@/components/Pagination'
import SearchSupplierModule from '@/views/modules/supplier/Search'

export default {
  name: 'SupplierModuleList',
  components: {
    Pagination,
    SearchSupplierModule,
    DeleteModulesToInventory: () => import('@/views/batch_operations/DeleteModulesToInventory')
  },
  data() {
    return {
      data: [],
      loading: true,
      isShowDeleteToInventoryModal: false,
      selectedRowKeys: [],
      pagination: {
        total_count: 0
      },
      query: {},
      columns: [
        {
          title: 'IMEI',
          dataIndex: 'imei',
          width: 180,
          fixed: 'left'
        },
        {
          title: '模组厂商',
          dataIndex: 'module_producer_name',
          width: 140
        },
        {
          title: '模组型号',
          dataIndex: 'module_model_name',
          width: 140
        },
        {
          title: 'SN',
          dataIndex: 'sn',
          width: 160
        },
        {
          title: '箱号',
          dataIndex: 'box_number',
          width: 120
        },
        {
          title: '盘号',
          dataIndex: 'reel_number',
          width: 120
        },
        {
          title: '固件版本',
          dataIndex: 'firmware_version',
          width: 120
        },
        {
          title: '划拨时间',
          dataIndex: 'allocated_at',
          width: 170
        },
        {
          title: '所属客户',
          dataIndex: 'agent_name',
          width: 160
        }
      ]
    }
  },
  computed: {
    moduleSupplierId() {
      return parseInt(this.$route.params.id)
    },
    isAdmin() {
      return this.$store.getters.userRole === 'super_admin' || this.$store.getters.userRole === 'admin'
    },
    selectedImeis() {
      return this.data
        .filter((item) => this.selectedRowKeys.includes(item.id))
        .map((item) => item.imei)
        .filter((imei) => imei)
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },

    showDeleteToInventoryModal() {
      this.isShowDeleteToInventoryModal = true
    },

    submitSearch(search) {
      this.query = Object.assign({},
        this.$options.data().query,
        { per_page: this.query.per_page },
        search
      )
      this.fetchData()
    },

    fetchData() {
      this.loading = true
      this.selectedRowKeys = []
      findModuleSupplierModules(this.moduleSupplierId, this.query).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.pagination = res.pagination
        }
        this.loading = false
      })
    }
  }
}
</script>
